export const getContent = (state) => state.contentFilter.content;
export const getActiveFilters = (state) => state.contentFilter.activeFilters;
export const getDisplayItemCount = (state) => state.contentFilter.displayItemCount;
export const getContentType = (state) => state.contentFilter.contentType;
export const getCanShowMore = (state) => state.contentFilter.canShowMore;

const filterContent = (state) => {
  const content = getContent(state);
  const activeFilters = getActiveFilters(state);

  if (activeFilters?.length === 0) return content;

  return content.filter((item) => activeFilters.every((filter) => item[filter.key] === filter.value));
};

export const getFilterContentByDisplayCount = (state) => {
  const content = filterContent(state);
  const displayCount = getDisplayItemCount(state);

  return content.slice(0, displayCount);
};
